import { Box, Container, Typography } from "@mui/material";

import MenuTabs from "../../components/tabs/MenuTabs";

const Tokens = () => {
  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        maxWidth: "1200px",
        pt: { xs: "37px", md: "52.12px" },
      }}
    >
      <Box
        sx={{
          px: {
            xs: "24px",
            md: "120px",
          },
        }}
      >
        <Box>
          <Typography
            sx={{
              fontWeight: "700",
              fontSize: { xs: "28px", md: "36px" },
              lineHeight: { xs: "42px", md: "46px" },
              letterSpacing: "-0.02em",
            }}
            color="#242424"
          >
            Tokens
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: "14px", md: "16px" },
              lineHeight: "24px",
              letterSpacing: "-0.02em",
              color: "#6F6F6F",
            }}
          >
            You can check the supply and distribution status of SFL and TRI
            token.
          </Typography>
        </Box>

        <MenuTabs />
      </Box>
    </Container>
  );
};

export default Tokens;
